const resource = '/shop-api/brand'

export default (ctx, $axios) => ({
  getBrands () {
    return $axios.$get(`${resource}/getallnameandurls`);
  }
})
